import React from 'react';
import { Flex } from '../../../../Layout';

export const Line = () => <Flex css={{ w: '100%', borderBottom: '1px solid $border_bright', h: '1px', my: '$8' }} />;
